import React, { useEffect, useState } from "react";

import { useHistory } from "react-router-dom";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import { URLS } from "configs/constants";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const customFields = [
  {
    label: "Company",
    value: "company",
    redirectTo: URLS.COMPANY_CUSTOM_FIELDS,
  },
  {
    label: "District",
    value: "district",
    redirectTo: URLS.DISTRICT_CUSTOM_FIELDS,
  },
  {
    label: "Grievance Type",
    value: "grievance_type",
    redirectTo: URLS.GRIEVANCE_TYPE_CUSTOM_FIELDS,
  },
  {
    label: "ID Type",
    value: "id_type",
    redirectTo: URLS.ID_TYPE_CUSTOM_FIELDS,
  }, 
  {
    label: "Role Mapping",
    value: "role_mapping",
    redirectTo: URLS.ROLEMAPPING_CUSTOM_FIELDS,
  },
  {
    label: "Source",
    value: "source",
    redirectTo: URLS.SOURCE_CUSTOM_FIELDS,
  },
  {
    label: "State",
    value: "state",
    redirectTo: URLS.STATE_CUSTOM_FIELDS,
  },
  
  {
    label: "Urgency Level",
    value: "urgency_level",
    redirectTo: URLS.URGENCY_LEVEL_CUSTOM_FIELDS,
  },
  {
    label: "Worker Group",
    value: "worker_group",
    redirectTo: URLS.WORKER_GROUP_CUSTOM_FIELDS,
  },

];

const CustomFields = (props) => {
  const [selectedValue, setSelectedValue] = useState(
    props.value ? props.value : URLS.WORKER_GROUP_CUSTOM_FIELDS
  );
  
  const history = useHistory();
  const { t } = useTranslation();

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
  };

  useEffect(() => {
    history.push(selectedValue);
  }, [selectedValue]);

  return (
    <>
      <Select onChange={handleChange} value={selectedValue}>
        {customFields.map((customField) => {
          return (
            <MenuItem
              value={customField.redirectTo}
              key={customField.redirectTo}
            >
              {t(customField.label)}
            </MenuItem>
          );
        })}
      </Select>
    </>
  );
};
CustomFields.propTypes = {
  value: PropTypes.string,
};

export default CustomFields;
